import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { toolbarContext } from "../searchResultsView";
import EmailMessageViewModel from "viewModels/callCenter/search/emailMessage/emailMessageViewModel";

const EmailMessageViewView: ViewComponent<EmailMessageViewModel> = observer(({ vm }) => {
  return null;
});

registerView(EmailMessageViewView, EmailMessageViewModel, toolbarContext);
